import { Webchat, WebchatProvider, getClient } from "@botpress/webchat";
import { buildTheme } from "@botpress/webchat-generator";
import { useState, useEffect } from "react";

const { theme, style } = buildTheme({
  themeName: "prism",
  themeColor: "#634433",
  customStyle: `
    /* Custom CSS for the input field border color */
    .bpw-composer .bpw-input-wrapper {
      border: 2px solid red !important; /* Force the border color to red */
      border-radius: 5px;
      padding: 8px;
    }
    
    .bpw-composer .bpw-input-wrapper input {
      border: none !important; /* Remove any default input border */
      outline: none;
      width: 100%;
      font-size: 16px;
      padding: 5px;
      color: #634433;
      background-color: #f5f5f5; /* Optional: background color */
    }
    
    .bpw-composer .bpw-input-wrapper input:focus {
      border: 2px solid red !important; /* Keep border color red on focus */
      box-shadow: none !important; /* Remove any focus shadow */
    }
  `,
});

// Add your Client ID here ⬇️
const clientId = "f65c082e-f018-4fdd-80c8-9ff5d23e67cc";
// 58e3ac15-2af0-4d8d-80b9-b1081b1f18a1

export default function App() {
  const client = getClient({ clientId });
  const [isWebchatOpen, setIsWebchatOpen] = useState(true);

  const config = {
    composerPlaceholder: "Ask your query",
    botName: "Agicent Help Buddy",
    botAvatar: "https://www.agicent.com/assets/images/site_logo/favicon/android-chrome-192x192.png",
    botDescription: "This chatbot was built to help you!",
    showPoweredBy: false,
    enableConversationDeletion: true,
    containerWidth: "100%",
    layoutWidth: "100%",
    hideWidget: true,
    showCloseButton: false,
    disableAnimations: false,
    closeOnEscape: false,
    showConversationsButton: false,
    enableTranscriptDownload: true,
  };

  useEffect(() => {
    setIsWebchatOpen(true);
  }, []);

  return (
    <div style={{ width: "100vw", height: "100vh", display: "flex", flexDirection: "column" }}>
      <style>{style}</style>
      
      {/* Fixed Header */}
      {/* <header style={{
        flexShrink: 0,
        padding: "10px",
        backgroundColor: "#634433",
        color: "white",
        textAlign: "center"
      }}>
        Agicent Help Buddy
      </header> */}

      {/* Scrollable Chat Content */}
      <div style={{ flexGrow: 1, overflowY: "auto" }}>
        <WebchatProvider theme={theme} client={client} configuration={config}>
          <Webchat />
        </WebchatProvider>
      </div>

      {/* Fixed Footer */}
      <footer style={{
        flexShrink: 0,
        padding: "10px",
        backgroundColor: "#634433",
        color: "white",
        textAlign: "center"
      }}>
        © 2025 Agicent Technologies
      </footer>
    </div>
  );
}
